<template>
  <div>
    <!-- Header -->
    <div class="header py-7 py-lg-8 pt-lg-9">
     
    </div>
    <!-- Page content -->
    <div class="container mt--8 pb-5">

      <div slot="brand" class="text-center col-12 p-4">
        <img src="/img/brand/food-drop-logo-white.svg" style="width: 16rem;">
      </div>

      <div class="row justify-content-center">
        <div class="col-lg-5 col-md-7">
          <div class="card bg-secondary border-0 mb-0">
            <div class="card-body px-lg-5 py-lg-5">
              <div class="text-center text-muted mb-4">
                <small>Sign in with credentials</small>
              </div>
              <form role="form">
                <base-input alternative
                            class="mb-3"
                            prepend-icon="ni ni-email-83"
                            placeholder="Email"
                            autofocus
                            v-model="model.email"
                            @keypress.enter="doLogin()">
                </base-input>

                <base-input alternative
                            class="mb-3"
                            prepend-icon="ni ni-lock-circle-open"
                            type="password"
                            placeholder="Password"
                            v-model="model.password"
                            @keypress.enter="doLogin()">
                </base-input>

                <!-- <base-checkbox v-model="model.rememberMe">Remember me</base-checkbox> -->
                <div class="text-center">
                  <base-button type="success" class="my-4" @click="doLogin()">Sign in</base-button>
                </div>
              </form>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-12 text-right">
              <router-link to="/auth/forgot-password" class="text-white"><small>Forgot password?</small></router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  // Modules
  import validator from 'validator';

  // Services
  import AuthService from '../../../services/AuthService'
  import UsersService from '../../../services/UsersService'
  import UserStore from '../../../services/UserStore'

  export default {
    data() {
      return {
        model: {
          email: '',
          password: ''
        }
      };
    },

    mounted: function() {

    },

    methods: {
      async doLogin() {
        if(!validator.isEmail(this.model.email) || this.model.password.trim().length === 0) {
          alert('To sign in, you must provide valid values for all fields.')
          return;
        }
      
        const authResult = await AuthService.loginWeb(this.model.email, this.model.password);

        if(authResult === true) {
          // Wait for 100ms for http-only cookie to store before making further requests
          setTimeout(async () => {
            try {

              const userRes = await UsersService.getOwn();


              UserStore.setUserData(userRes.data);

              // Navigate to the relevant dashboard page
              switch(UserStore.userData.group) {
                case 'admins':
                  this.$router.push('/admin/dashboard');
                  break;

                case 'retailerLead':
                  this.$router.push('/lead-retailer/dashboard');
                  break;

                case 'retailers':
                  this.$router.push('/retailer/dashboard');
                  break;

                case 'charities':
                  this.$router.push('/charity/dashboard');
                  break;

                default:
                  this.$router.push('/404');
                  break;
              }
            }
            catch(err) {
            }
          }, 100);
        }
        else if (authResult === false) {
          alert('Email address or password incorrect, or account not verified.');
        }
        else {
          alert('Oops, something went wrong. Please try again.');
        }
      }
    }
  };
</script>
